import type { CountersResponse } from '@prerender/diagnostics-api';

import api from '../../api/apiSlice';

export const countersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCounters: builder.query<CountersResponse, void>({
      query: () => '/diagnostics/counters',
      providesTags: [{ type: 'Incident', id: 'LIST' }],
    }),
  }),
});

export const { useGetCountersQuery } = countersApi;
